import React from 'react';
import { useSelector } from 'react-redux';

import MentalImage from '../../assets/images/death_reasons/mentalImage';
import MentalEng from '../../assets/images/death_reasons/mentalEng';
import MentalRus from '../../assets/images/death_reasons/mentalRus';
import Border from '../../assets/images/border';

import './mental.scss';

const Mental = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='mental'>
            <Border />
            {language === 'ENG' ? <MentalEng /> : <MentalRus />}
            <MentalImage />
            <span className='mental-text'>
                {language === 'RUS' ? 'При высоком риске психических расстройств эмоциональная нестабильность и когнитивные нарушения могут серьёзно подорвать здоровье и заметно сократить продолжительность жизни.' : 'High risk of mental disorders emotional instability and cognitive impairments can seriously undermine health and significantly reduce life expectancy.'}
            </span>
        </div>
    );
};

export default Mental;